module.exports = __webpack_public_path__ + "static/og-image-b7f18b00b684380a1c2aafad66dd6511.jpg";